import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnDestroy, OnInit, Output } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { IconsModule, SVGIcon } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ActionSheetItem, NavigationModule } from '@progress/kendo-angular-navigation';
import { Test1Component } from '../tiles/test1/test1.component';
import { LoggerService } from '../../shared/logger.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { TrackerService } from '../tracker.service';
import { Subscription } from 'rxjs';
import { KENDO_TOOLBAR } from '@progress/kendo-angular-toolbar';
import { KENDO_LABELS } from '@progress/kendo-angular-label';
import { bellIcon, filterIcon, menuIcon, xIcon } from '@progress/kendo-svg-icons';
import { CasiToolbarTitleComponent } from '../casi-toolbar-title/casi-toolbar-title.component';
import { CasiTileHeaderComponent } from '../casi-tile-header/casi-tile-header.component';
import { CasiEventService } from '../casi-event.service';
import { CasiEventName } from '../../common/constants.lib';
import { CasiStoryEstimate, CasiStoryPriority, CasiStoryStatus, CasiStoryType, CasiUserStory, User as UserModel, UserStory } from '../../models/models.lib';
import { MenusModule } from '@progress/kendo-angular-menu';
import { CasiEvent, TileItem } from '../../common/obj.lib';

@Component({
  selector: 'casi-tile-layout',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    ButtonsModule,
    IndicatorsModule,
    RouterModule,
    IconsModule,
    NavigationModule,
    FontAwesomeModule,
    KENDO_TOOLBAR,
    KENDO_LABELS,
    CasiTileHeaderComponent,
    MenusModule
  ],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './tile-layout.component.html',
  styleUrl: './tile-layout.component.scss'
})
export class TileLayoutComponent implements OnInit, OnDestroy, AfterContentInit {
  private _tiles: TileItem[] = [];
  @Input({ required: true })
  set tiles(value: TileItem[]) {
    this._tiles = value;
    // this._tiles.forEach(t => this.tileList.push(t));
  }
  get tiles() {
    return this._tiles;
  }

  @Input() set tileToAdd(value: TileItem) {
    this.tileList.push(value);
  }
  @Input({ required: true }) public users: UserModel[] = [];

  private _userStories: CasiUserStory[] = [];
  @Input({ required: true })
  set userStories(val: CasiUserStory[]) {
    this._userStories = val;
  }
  get userStories() {
    return this._userStories;
  }

  @Input({ required: true }) public storyStatus: CasiStoryStatus[] = [];
  @Input({ required: true }) public storyTypes: CasiStoryType[] = [];
  @Input({ required: true }) public storyPriorities: CasiStoryPriority[] = [];
  @Input({ required: true }) public storyEstimates: CasiStoryEstimate[] = [];
  @Input() public selectedUserStoryId: string | null = null;

  public tileList: TileItem[] = [];

  public filterIcon: SVGIcon = filterIcon;
  public menuIcon: SVGIcon = menuIcon;
  public xIcon: SVGIcon = xIcon;
  public onClick(): void {
    console.log("on click");
  }



  @Output() onCloseTile = new EventEmitter<TileItem>();

  tileLayoutEmitter = new EventEmitter<TileItem | undefined>();

  private _subs: Subscription[] = [];
  myContent?: any[][];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private trackerService: TrackerService,
    private casiEventService: CasiEventService
  ) {
    faIcons.addIcons(...all);

    // this.tiles.push());
  }

  //#region NG Event Handlers

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.tileLayoutEmitter.emit();
  }

  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
  }

  //#endregion

  public closeTile(tile: TileItem) {
    this.logger.debug(`closeTile: `, tile.name);
    this.onCloseTile.emit(tile);
  }

  public addToTile(tile: TileItem) {
    this.logger.debug(`addToTile: `, tile);
    this.casiEventService.casiEvent = new CasiEvent(CasiEventName.add, tile.componentName);
  }

  public showMenu(tile: TileItem) {
    this.logger.debug(`showMenu...`, tile);
  }

  getCurrentItem(item: TileItem): Record<string, TileItem> {
    return {
      'tile': item
    };
  }
  getInputs(item: TileItem) {
    return {
      'tile': item,
      'users': this.users,
      'userStories': this.userStories,
      'storyStatus': this.storyStatus,
      'storyTypes': this.storyTypes,
      'storyPriorities': this.storyPriorities,
      'storyEstimates': this.storyEstimates,
      'selectedUserStoryId': this.selectedUserStoryId
    };
  }
  getUsers(): Record<string, UserModel[]> {
    return {
      'users': this.users
    };
  }
}
